/**
 * Intent Service
 * 
 * Frontend service for classifying user intent from messages.
 */

import { getAtlasApiBaseUrl } from '../getAtlasApiBaseUrl';
import { atlasFetch } from '../api/atlasBackendClient';

export interface ClassifyIntentRequest {
  message: string;
  conversation_history?: Array<{ role: 'user' | 'assistant'; content: string }>;
}

export interface ClassifyIntentResponse {
  intent: 'knowledge_query' | 'ticket_creation' | 'mixed' | 'general_chat';
  confidence: number;
  reasoning: string;
}

export class IntentService {
  private baseUrl: string;
  
  constructor() {
    this.baseUrl = getAtlasApiBaseUrl();
  }
  
  /**
   * Classify user intent from a message
   */
  async classifyIntent(
    message: string,
    conversationHistory?: Array<{ role: 'user' | 'assistant'; content: string }>
  ): Promise<ClassifyIntentResponse> {
    try {
      const response = await atlasFetch(`${this.baseUrl}/api/conversation/classify-intent`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message,
          conversation_history: conversationHistory || [],
        } as ClassifyIntentRequest),
      });
      
      if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Unknown error' }));
        throw new Error(error.detail || `HTTP ${response.status}`);
      }
      
      return await response.json() as ClassifyIntentResponse;
    } catch (error) {
      console.error('Error classifying intent:', error);
      throw error;
    }
  }
}

// Export singleton instance
export const intentService = new IntentService();

